import { BuildingStatus } from '../land/state'

// Castle5 only has support building
export interface Castle5State {
  buildingStatus: Partial<BuildingStatus>
  isLoading: boolean
  isImmediate: boolean
  error?: string
  isRestored: boolean
  repairRequirements: {
    ecsToken: number
    gem: number
    iron?: number
    stone: number
    wood: number
    repairTime?: number
    repairCooldown?: Date | null
  }
  supportCharacters: any[]
  isSetSupportCharacterSuccess: boolean
  supportState: boolean
  upgradeRequirements: {
    ecsToken: number
  }
  upgradeAvailable: boolean
  allMiningStatus: {
    [key: string]: any
  }
}

export const initialCastle5State: Castle5State = {
  buildingStatus: {
    support: {
      level: 0,
      hp: 0,
      maxHp: 0,
      characters: []
    },
    boostingTree: {
      level: 1,
      hp: 1000,
      maxHp: 1000,
    },
  },
  isLoading: false,
  isImmediate: false,
  error: undefined,
  isRestored: false,
  repairRequirements: {
    ecsToken: 0,
    gem: 0,
    iron: 0,
    stone: 0,
    wood: 0,
    repairTime: 0,
    repairCooldown: null,
  },
  supportCharacters: [],
  isSetSupportCharacterSuccess: false,
  supportState: false,
  upgradeRequirements: {
    ecsToken: 0,
  },
  upgradeAvailable: false,
  allMiningStatus: {},
}
